import React from 'react';
import loadable from '@loadable/component';
import Slider from 'react-slick';
import parse from 'html-react-parser';
import { roomSizeStatic } from '../../static-data/productStatic';
import { SUPPORTED_REGIONS } from '../../../shared/enums';

import milaWithBox from '../../../assets/images/products/CC-product-with-box.png';
import milaWithBoxWebp from '../../../assets/images/products/CC-product-with-box.png?as=webp';

const ImageLoader = loadable(() => import('../common/ImageLoader'));

const iconBox = (
  <svg
    width='48'
    height='49'
    viewBox='0 0 48 49'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M23.1562 46.4838V23.7585L45.4584 14.2695V36.1486L23.1562 46.4838Z'
      fill='var(--primary-color)'
      fillOpacity='0.2'
    />
    <path
      d='M2 36.1922V12.654L24.0629 2L46 12.687V36.1922L24.0629 46.8462L2 36.1922Z'
      stroke='var(--primary-color)'
      strokeWidth='4'
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M2 13L23.5607 23.1538L44.3077 13'
      stroke='var(--primary-color)'
      strokeWidth='4'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M23.1562 29.0769L23.1563 45.1538'
      stroke='var(--primary-color)'
      strokeWidth='4'
    />
    <path
      d='M19.7695 29.077L23.1541 26.5386L26.5388 29.077'
      stroke='var(--primary-color)'
      strokeWidth='4'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
const iconGrid = (
  <svg
    width='45'
    height='44'
    viewBox='0 0 45 44'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10.1289 40.4081L10.1289 3.5918'
      stroke='var(--primary-color)'
      strokeOpacity='0.2'
      strokeWidth='4'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M26.2891 40.4079L26.2891 3.59161'
      stroke='var(--primary-color)'
      strokeOpacity='0.2'
      strokeWidth='4'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M40.6596 34.1223L2.94531 34.1223'
      stroke='var(--primary-color)'
      strokeWidth='4'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M40.6596 34.1223L2.94531 34.1223'
      stroke='var(--primary-color)'
      strokeWidth='4'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M41.558 9.87768L3.84375 9.87769'
      stroke='var(--primary-color)'
      strokeWidth='4'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M41.558 9.87768L3.84375 9.87769'
      stroke='var(--primary-color)'
      strokeWidth='4'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M40.6596 17.959L2.94531 17.959'
      stroke='var(--primary-color)'
      strokeWidth='4'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M40.6596 17.959L2.94531 17.959'
      stroke='var(--primary-color)'
      strokeWidth='4'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M41.558 26.0409L3.84375 26.0409'
      stroke='var(--primary-color)'
      strokeWidth='4'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M41.558 26.0409L3.84375 26.0409'
      stroke='var(--primary-color)'
      strokeWidth='4'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M18.2109 40.4079L18.2109 3.59161'
      stroke='var(--primary-color)'
      strokeOpacity='0.2'
      strokeWidth='4'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M34.3711 40.4081L34.3711 3.5918'
      stroke='var(--primary-color)'
      strokeOpacity='0.2'
      strokeWidth='4'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <rect
      x='2.25'
      y='2'
      width='40'
      height='40'
      rx='3'
      stroke='var(--primary-color)'
      strokeWidth='4'
    />
  </svg>
);
const iconCarbon = (
  <svg
    width='45'
    height='44'
    viewBox='0 0 45 44'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M20.4922 6.97592L26.3289 3.59131L32.1657 6.97592V14.574L26.3289 17.9587L20.4922 14.574V6.97592Z'
      fill='var(--secondary-color)'
    />
    <path
      d='M32.168 6.97592L38.0562 3.59131L43.9444 6.97592V14.574L38.0562 17.9587L32.168 14.574V6.97592Z'
      fill='var(--secondary-color)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M25.6008 2.33263C26.0521 2.07093 26.6089 2.07093 27.0602 2.33263L32.1929 5.30899L37.7618 2.31037C38.1924 2.07853 38.7106 2.07853 39.1411 2.31037L43.5068 5.69498C43.978 5.9487 44.2718 6.44064 44.2718 6.9758V14.5739C44.2718 15.1091 43.978 15.601 43.5068 15.8547L39.907 18.6456L39.907 18.6493V25.5945C39.9519 25.6131 39.9961 25.6341 40.0395 25.6574L43.5577 27.5087C44.0288 27.7624 44.3227 28.2544 44.3227 28.7895L44.4484 38.7451C44.4484 39.2803 44.1546 39.7722 43.6834 40.0259L40.0395 42.5864C39.6089 42.8182 39.0907 42.8182 38.6601 42.5864L33.0912 39.5877L27.9587 42.564C27.5074 42.8257 26.9505 42.8257 26.4992 42.564L21.4233 39.6206L16.7803 42.5374C16.3073 42.8346 15.7058 42.8346 15.2327 42.5374L10.5611 39.6027L5.01996 42.5864C4.58941 42.8182 4.07118 42.8182 3.64062 42.5864L4.3303 39.6534L9.16132 37.0521V31.1917L8.85534 31.027C8.74592 30.9946 8.63944 30.9491 8.53826 30.8904L7.71301 30.4119L4.3303 28.5904L4.29215 28.4282L2.70152 27.5058C2.25278 27.2456 1.97656 26.7661 1.97656 26.2474V18.6492C1.97656 18.1305 2.25278 17.651 2.70152 17.3908L3.25204 17.0716L3.43198 16.3064L8.263 13.705V7.84468L3.43198 5.24336L2.74231 2.31037C3.17286 2.07853 3.69109 2.07853 4.12165 2.31037L9.66275 5.29404L14.3343 2.35938C14.8073 2.06219 15.4088 2.06219 15.8819 2.35938L20.5248 5.27608L25.6008 2.33263ZM19.0391 13.7711V7.77857L15.1081 5.3091L11.175 7.77987V13.7698L15.1081 16.2406L19.0391 13.7711ZM26.3305 16.2768L21.9505 13.737V7.81249L26.3305 5.27263L30.7111 7.81284V13.7366L26.3305 16.2768ZM22.849 37.0841V31.1597L27.2289 28.6198L31.6094 31.1599V37.0838L27.2289 39.624L22.849 37.0841ZM19.9375 31.1256L16.0065 28.6561L12.0735 31.1269V37.1169L16.0065 39.5876L19.9375 37.1182V31.1256ZM13.65 25.4093L9.273 27.9475L9.13277 27.872L4.88595 25.4093V19.4873L9.26799 16.9462L13.65 19.4873V25.4093ZM34.5204 37.0529L39.3498 39.6534L44.1808 37.0521V31.1917L39.3498 28.5904L34.5204 31.1909V37.0529ZM25.3242 19.4864V25.4104L20.9438 27.9505L16.5617 25.4094V19.4874L20.9438 16.9463L25.3242 19.4864ZM28.2352 25.4104L32.6156 27.9505L36.9976 25.4094V19.4874L32.6156 16.9463L28.2352 19.4864V25.4104ZM33.6219 7.84389V13.7058L38.4515 16.3064L43.2825 13.705V7.84468L38.4515 5.24336L33.6219 7.84389Z'
      fill='var(--primary-color)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M39.651 3.8787H5.34898C4.81338 3.8787 4.37918 4.31289 4.37918 4.84849V39.1505C4.37918 39.6861 4.81338 40.1203 5.34898 40.1203H39.651C40.1866 40.1203 40.6208 39.6861 40.6208 39.1505V4.84849C40.6208 4.31289 40.1866 3.8787 39.651 3.8787ZM5.34898 -0.000488281C2.67096 -0.000488281 0.5 2.17047 0.5 4.84849V39.1505C0.5 41.8286 2.67096 43.9995 5.34898 43.9995H39.651C42.329 43.9995 44.5 41.8285 44.5 39.1505V4.84849C44.5 2.17047 42.329 -0.000488281 39.651 -0.000488281H5.34898Z'
      fill='var(--primary-color)'
    />
  </svg>
);
const iconFilter = (
  <svg
    width='49'
    height='44'
    viewBox='0 0 49 44'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M44.5811 31.0971L26.3763 23.1559L5.79688 31.0971L26.3763 40.6884L44.5811 31.0971Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.750061 31.9071C0.744272 31.2313 1.15214 30.579 1.86025 30.258L12.8915 25.2571L14.2247 28.7268L7.23287 31.8965L25.1559 39.9159L42.3174 31.9361L35.331 28.7409L36.6777 25.2755L47.6442 30.291C47.7458 30.3373 47.8433 30.3915 47.9355 30.4533C48.2327 30.6524 48.4561 30.9178 48.593 31.2149C48.8057 31.6746 48.796 32.1756 48.6018 32.6108C48.464 32.9197 48.2334 33.1955 47.9235 33.3998C47.8407 33.4544 47.7537 33.503 47.6634 33.5452C47.6616 33.5461 47.6598 33.5469 47.658 33.5478L26.0815 43.5805C25.5205 43.8414 24.8576 43.846 24.2923 43.5931L1.86958 33.5603C1.15634 33.2412 0.744242 32.5862 0.750061 31.9071Z'
      fill='var(--primary-color)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M25.7093 10.2265C25.1474 9.96948 24.4856 9.96842 23.9227 10.2236L1.86025 20.2254C1.15217 20.5463 0.744305 21.1986 0.75006 21.8744C0.744275 22.5535 1.15637 23.2084 1.86958 23.5275L24.2923 33.5603C24.8576 33.8132 25.5205 33.8085 26.0815 33.5477L47.6367 23.5248C47.8498 23.4288 48.0452 23.2979 48.2115 23.1354C48.367 22.9835 48.4912 22.8098 48.581 22.6229C48.8162 22.1353 48.7984 21.5991 48.5743 21.143C48.4939 20.9793 48.3869 20.8259 48.2556 20.6888C48.2235 20.6553 48.1899 20.6228 48.155 20.5913C47.9983 20.4502 47.8186 20.3354 47.6246 20.2494L25.7093 10.2265ZM42.3172 21.9033L24.8089 13.8959L7.23306 21.8637L25.1559 29.8831L42.3172 21.9033Z'
      fill='var(--primary-color)'
    />
    <path
      d='M43.4913 11.655L25.2865 3.71377L4.70703 11.655L25.2865 21.2463L43.4913 11.655Z'
      fill='#FDE0E5'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M25.7093 0.193515C25.1474 -0.0634917 24.4856 -0.0645542 23.9227 0.190646L1.86025 10.1924C1.15217 10.5134 0.744305 11.1657 0.75006 11.8414C0.744276 12.5205 1.15637 13.1754 1.86958 13.4945L24.2923 23.5273C24.8576 23.7802 25.5205 23.7756 26.0815 23.5147L47.6369 13.4918C47.8455 13.3978 48.037 13.2703 48.2009 13.1126C48.3625 12.9573 48.491 12.7785 48.5829 12.586C48.8012 12.1286 48.8133 11.5933 48.5734 11.1082C48.4845 10.9278 48.3634 10.76 48.2128 10.6126C48.043 10.4464 47.8428 10.313 47.6244 10.2163L25.7093 0.193515ZM42.3172 11.8703L24.8089 3.86295L7.23306 11.8307L25.1559 19.8501L42.3172 11.8703Z'
      fill='var(--primary-color)'
    />
  </svg>
);

const featuresItems = [
  {
    icon: iconBox,
    title: () => (
      <>
        350 m
        <sup>3</sup>
        /hr CADR
      </>
    ),
    description: size => (
      <p>
        Works its best magic in living rooms and larger bedrooms. Refreshes a
        {' '}
        {parse(`${size}`)}
        {' '}
        space every 30 min.
      </p>
    ),
  },
  {
    icon: iconGrid,
    title: () => <>H13 HEPA Filter</>,
    description: () => (
      <p>H13 HEPA filter optimized for dander and dust allergies.</p>
    ),
  },
  {
    icon: iconCarbon,
    title: () => <>Granular Carbon Filter</>,
    description: () => (
      <p>
        0.84 lbs of modified granular carbon specifically targeted for ammonia
        removal.
      </p>
    ),
  },
  {
    icon: iconFilter,
    title: () => <>Pre Filter</>,
    description: () => (
      <p>Comes with a washable Mila Sock for fur and larger particles.</p>
    ),
  },
];

const FeatureItem = ({
  icon, title, description, size,
}) => (
  <div className='featured-list__item features-item'>
    <div className='features-item__card'>
      <div className='features-item__icon'>{icon}</div>
      <h3 className='features-item__title'>{title()}</h3>
      <div className='features-item__description'>{description(size)}</div>
    </div>
  </div>
);

const FeaturesGrid = ({ localization, type }) => {
  const settings = {
    infinite: true,
    arrows: false,
    dots: false,
    variableWidth: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const { region } = localization;
  const regional = SUPPORTED_REGIONS[region] || SUPPORTED_REGIONS.US;

  const size = roomSizeStatic[type][regional].filter;

  return (
    <>
      <div className='featured-list featured-list--default'>
        {featuresItems.map(featuresItem => (
          <FeatureItem key={featuresItem.title} {...featuresItem} size={size} />
        ))}
      </div>
      <Slider className='featured-list featured-list--slider' {...settings}>
        {featuresItems.map(featuresItem => (
          <FeatureItem key={featuresItem.title} {...featuresItem} size={size} />
        ))}
      </Slider>
    </>
  );
};

const ProductFeatures = ({ localization, type }) => (
  <div
    className='product-features'
    style={{ '--primary-color': '#F42D53', '--secondary-color': '#FFF2F5' }}
  >
    <div className='container container--md'>
      <div className='product-features__grid'>
        <div className='product-features__content'>
          <h2 className='product-features__title'>
            Her
            {' '}
            <span style={{ color: 'var(--primary-color)' }}>
              Critter Cuddler
            </span>
            {' '}
            🐶 filter was designed just for you.
            {' '}
          </h2>
          <div className='product-features__description product-features__description--highlited'>
            <p>
              Designed for pets and their humans, this HEPA + heavy-duty carbon
              filter removes pet dander and odors to keep your place free of
              animal funk and allergens.
              {' '}
            </p>
          </div>
          <div className='product-features__description product-features__description--default'>
            <p>
              Ever met an air purifier you truly loved? Neither had we. So we
              created Mila—the first air purifier designed with real,
              air-breathing humans in mind. Unlike traditional air purifiers
              that come with three manual speeds and a button called auto, Mila
              is a truly smart air purifier that’s light years ahead.
            </p>
          </div>
        </div>
        <div className='product-features__media'>
          <ImageLoader
            className='product-features__image img-relative'
            placeholderAspectRatio={631 / 526}
            image={milaWithBox}
            webp={milaWithBoxWebp}
            alt='Critter Cuddler filter with box'
          />
        </div>
      </div>
      <FeaturesGrid type={type} localization={localization} />
    </div>
  </div>
);

export default ProductFeatures;
